export const sections = {
  partners: 'partners',
  science_council: 'science_council',
  trustee_council: 'trustee_council',
};
